module.exports = __webpack_public_path__ + "img/Signes_bifurcations_a8a23d6e8aa8c333bcbbb435abf70ab6.longcache.png";